import { useEffect } from "react";
import { useAnonymousAuth } from "../queries/useAuth";

/**
 * Call POST /auth/anonymous on first mount to make sure the backend has
 * planted the HttpOnly __session cookie. Idempotent — the Worker will reuse
 * an existing cookie if present.
 */
export function useSession() {
  const auth = useAnonymousAuth();

  useEffect(() => {
    if (auth.isIdle) {
      auth.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return auth;
}
